export default "__VITE_ASSET__4c67333c__"